import React from 'react';
import { Zap, BookOpen, Rocket, Target, Users, Heart, Globe, Briefcase } from 'lucide-react';

export const interests = [
  { id: 'tech', label: 'Technology', icon: <Zap size={18} /> },
  { id: 'edu', label: 'Education', icon: <BookOpen size={18} /> },
  { id: 'startup', label: 'Startups', icon: <Rocket size={18} /> },
  { id: 'design', label: 'Design', icon: <Target size={18} /> },
  { id: 'community', label: 'Community', icon: <Users size={18} /> },
  { id: 'health', label: 'Health', icon: <Heart size={18} /> },
  { id: 'world', label: 'World News', icon: <Globe size={18} /> },
  { id: 'business', label: 'Business', icon: <Briefcase size={18} /> },
];

export const getInterestLabel = (id) => {
  const interest = interests.find(i => i.id === id);
  return interest ? interest.label : id;
};

export const getInterestIcon = (id) => {
  const interest = interests.find(i => i.id === id);
  return interest ? interest.icon : null;
};
